module.exports = __webpack_public_path__ + "img/ml.ac6b5a41.svg";